<template>
	<div class="text-left shadow">
		<b-form @submit.prevent="console.log('Enter')">
			<div class="row mt-3 mb-3">
				<div class="col text-center">
					<h2>{{ config.title }}</h2>
				</div>
			</div>

			<b-form-row v-if="config.showDescription">
				<b-form-group label="Deskripsi" class=" col-12">
					<input type="text" class="form-control" v-model="desc" />
				</b-form-group>
			</b-form-row>

			<b-form-row>
				<b-form-group label="Tanggal Tercatat" class="col-12">
					<flat-pickr
						v-model="time_of_arrival"
						:config="rangeConfig"
						placeholder="Pilih Tanggal"
					></flat-pickr>
				</b-form-group>
				<b-form-group label="Supplier" class="col-12">
					<Multiselect 
						v-model="supplier"
						:options="supplierList.map(x => x.id)"
						:custom-label="opt => supplierList.find(x => x.id == opt).name"
						:allow-empty="false"
					/>
				</b-form-group>
				<b-form-group label="Harga Per Item" class="col-12" v-if="!estimator.is_supplied_by_insurance">
					<input type="text" class="form-control" v-model="price_per_item" />
				</b-form-group>
				<b-form-group label="Opsi PPN" class="col-12" v-if="!estimator.is_supplied_by_insurance">
					<Multiselect 
						v-model="ppn_included"
						:options="['Termasuk', 'Tidak Termasuk' , 'Tanpa PPN']"
						:allow-empty="false"
					/>
				</b-form-group>
				<b-form-group label="Unggah Gambar" class="col-12">
					{{ fileError }}
					<input
						:disabled="file.length >= config.imageCount"
						type="file"
						name="myImage"
						accept="image/*"
						class="form-control"
						@change="validateSize"
						multiple
					/>
					<br />
					<p v-if="config.imageCount > 1">
						Maksimal {{ config.imageCount }} Gambar
					</p>
				</b-form-group>
				
			</b-form-row>

			<b-form-row v-if="file.length > 0 && url.length > 0">
				<template class="w-100">
					<div
						v-for="(url, index) in url"
						:key="url"
						class="text-center row"
					>
						<b-form-group
							class="col-12 col-md text-center"
							style="width:225px"
						>
							<img
								:src="url"
								class="img-fluid"
								style="height:15vh;"
							/>
							<br />
							<button
								type="button"
								@click="deleteImage(index)"
								class="btn btn-warning w-50 mt-2"
							>
								Hapus
							</button>
						</b-form-group>
					</div>
				</template>
			</b-form-row>
			<b-form-row>
				<b-form-group class="col-6 text-center">
					<button
						type="button"
						@click="$emit('closeModal')"
						class="btn btn-danger w-75"
					>
						Batal
					</button>
				</b-form-group>
				<b-form-group class="col-6 text-center" v-if="file && url">
					<button
						type="button"
						@click="uploadImage"
						class="btn btn-primary w-75"
						:disabled="url.length == 0"
					>
						Unggah Gambar
					</button>
				</b-form-group>
			</b-form-row>
		</b-form>
	</div>
</template>

<script>
import watermark from 'watermarkjs'
import moment from 'moment'
import env from '@/env'
import Multiselect from 'vue-multiselect'
export default {
	components : {
		Multiselect
	},
	data () {
		let date = new moment().format('Y-MM-DD HH:mm:ss')
		return {
			config : {
				title : 'Unggah Gambar',
				imageCount : 1,
				maxFileSize : 20,
				endpoint : env.urlStart + '/api/v1/workorder/image',

				passData : null,

				showDescription : false,
			},
			rangeConfig: {
				altInput: true,
				altInputClass: 'form-control input flatpickr-input w-100',
				animate: !this.isRTL(),
				enableTime : true
			},
			file: [],
			fileError: '',
			url: [],
			desc : '',
			loading : false,
			time_of_arrival : date,
			supplierList : [],
			supplier : null,
			price_per_item : null,
			ppn_included : null
		}
	},
	props: [
		'title',//Title to be shown at the top; DEFAULT 'Unggah Gambar'
		'image_count',//Maximum number of images to be uploaded; DEFAULT '1'
		'max_file_size',//Maximum file size (in MB) ex. 4 == 4 MB; DEFAULT '8'
		'show_description',//Show description; DEFAULT false
		'pass_data',//Pass data upon uploading; DEFAULT null
		'endpoint',//Endpoint to upload image; DEFAULT '/api/v1/workorder/image',
		'estimator'
	],
	mounted () {
		this.validateProps();
		// console.log(this.estimator)
		this.supplier = this.estimator.supplier_id

		if(typeof this.estimator.without_ppn != 'object' && this.estimator.without_ppn) {
			this.ppn_included = 'Tanpa PPN'
		}
		else if(typeof this.estimator.ppn_included != 'object'){
			this.ppn_included = this.estimator.ppn_included ? 'Termasuk' : 'Tidak Termasuk'
		}
			

		this.price_per_item = this.estimator.price_per_item ? parseInt(this.estimator.price_per_item ? this.estimator.price_per_item : 0) : null
		this.supplierList = this.loadSupplierList()
	},
	methods: {
		loadSupplierList () {
			this.$http.get('/api/v1/masterData/supplier?pagination=false')
			.then((resp) => {
				this.supplierList = resp.data.data
			})
			.catch((err) => {
				console.log(err)
			})
		},
		validateProps () {
			if (this.title != null) {//Check 'title'
				if (typeof this.title == 'string')
					this.config.title = this.title
				else
					this.errorPrint('title must be a string');
			}

			if (this.image_count != null) {//Check 'image_count'
				if (typeof this.image_count == 'number')
					this.config.imageCount = this.image_count
				else
					this.errorPrint('image_count must be an integer');
			}

			if (this.max_file_size != null) {//Check 'max_file_size'
				if (typeof this.max_file_size == 'number')
					this.config.maxFileSize = this.max_file_size
				else
					this.errorPrint('max_file_size must be an integer');
			}

			if (this.endpoint != null) {//Check 'endpoint'
				if (typeof this.endpoint == 'string')
					this.config.endpoint = this.endpoint
				else
					this.errorPrint('endpoint must be a string');
			}

			if (this.show_description != null) {//Check 'show_description'
				if (typeof this.show_description == 'boolean')
					this.config.showDescription = this.show_description
				else
					this.errorPrint('show_description must be a boolean');
			}

			if (this.pass_data != null) {//Check 'pass_data'
				this.config.passData = this.pass_data
			}
		},
		// Change ValidateSize Function To Allow Multiple Image Selected - Marvin T
		validateSize : function(data){
				
			var file = data.target.files;

			if (file.length > 3) {
				this.fileError = "Maximum Gambar Diunduh 3 Gambar"
				return false
			}

			for(var i = 0 ; i < file.length ; i ++) {
				var size  = file[i].size / 1024 / 1024;

				if(size > this.config.maxFileSize)
				{
					this.fileError = `Limit Size Gambar ${this.config.maxFileSize} MB`;
					return false;
				}

				

				this.fileError = "";
				let blobURL = URL.createObjectURL(file[i])
				let vm = this;

				if(size > 1) {
					let img = new Image();
					img.src = blobURL;
					img.onload = function (ev) {
						let canvas = document.createElement('canvas');
						canvas.width = img.width;
						canvas.height = img.height;
						console.log

						let ctx = canvas.getContext('2d');
						ctx.drawImage(img, 0, 0, img.width, img.height);

						let base64 = canvas.toDataURL('image/jpeg' , 0.6)


						let modifiedFile = vm.dataURLtoFile(base64 , 'image.jpg')
						vm.file.push(modifiedFile)
						vm.url.push(URL.createObjectURL(modifiedFile))

					};
				}
				else {
					this.file.push(file[i]) ;
					this.url.push(blobURL);
				}
			}

			return true;
				
		},
		async uploadImage () {
			// console.log(this.loading)
			if(!this.supplier) {
				this.$store.dispatch('triggerAlert' , [false , 'Mohon diisi supplier tersebut'])
				return;
			}
			
			if(this.loading) {
				this.$store.dispatch('triggerAlert' , [false , 'Gambar Sedang diunggah. mohon ditunggu..'])
				return;
			}
			let image = await this.uploadAllImage()

			this.$emit('onResponse', this.config.showDescription ? {image : this.config.imageCount==1 ? image[0] : image, desc : this.desc} : this.config.imageCount==1 ? image[0] : image, this.time_of_arrival , {supplier : this.supplier , ppn_included : this.ppn_included == 'Termasuk' ? true : this.ppn_included =='Tanpa PPN' ? 'without_ppn' :false , price_per_item : this.price_per_item});
		},
		async uploadS3Image (blob , type) {
			let url = env.awsImageUploader

			let response = await this.$http.get(url + '?type=' + type)

			let data = response.data


			const result = await fetch(data.uploadURL, {
              method: 'PUT',
              body: blob
            })
			console.log(result)

			return data.Key
		},
		async uploadAllImage() {
			let image = []

			this.loading = true
			let length = this.file.length
			let counter = 0

			for(var i = 0 ; i < this.file.length ;  i++) {
				let vm = this
				let date = new moment().format('MMM DD, Y HH:mm:ss')
				let type = this.file[i].type.split('/')[1].toUpperCase()

				// await watermark([this.file[i]])
				// .blob(watermark.text.lowerRight(date, '50px Arial', '#fff', 1))
				// .then(async function (blob) {

				// Temporary Remove Watermark
				await fetch(URL.createObjectURL(this.file[i]))
				.then(res => res.blob())
				.then(async (blob) => {
					// let filename = await vm.uploadS3Image(blob , type)
					// image.push(filename)


					// if(counter == length) {
					// 	this.loading = false
					// }
					// else {
					// 	counter++
					// }
					let file = new File([blob], 'test.png');


					let formData = new FormData()

					formData.append('image', file)
					
					await vm.$http.post(vm.config.endpoint, formData, {headers : {"Content-Type":'multipart/form-data'}})
					.then((resp) => {
						image.push(resp.data.data.filename)
						if(counter == length) {
							this.loading = false
						}
						else {
						counter++
						}
					})
					.catch((err) => {
						this.$store.dispatch('triggerAlert' , [false , 'Something Went Wrong in Uploading Image File.'])
						this.loading = false
						console.log(err)
					})
				})


				
					// 
				// });
				
			}
			
			return image
		},
		deleteImage (index) {
			this.url.splice(index, 1)
			this.file.splice(index , 1)
		}
	}
}
</script>
